import { Component, Input, HostBinding } from '@angular/core';
import { cardAnimations } from './card-animations';

@Component({
  selector: 'mars-card',
  template: `
    <es-card no-padding>
      <ng-content select="mars-card-header"></ng-content>
      <div
        class="mars-card-body"
        [class]="getExpandedState()"
        role="region"
        [@bodyExpansion]="getExpandedState()"
      >
        <ng-content></ng-content>
      </div>
    </es-card>
  `,
  styleUrls: ['./card.component.scss'],
  animations: [cardAnimations.bodyExpansion],
})
export class CardComponent {
  @Input() disabled = false;

  @Input() expanded = true;

  toggle() {
    this.expanded = !this.expanded;
  }

  getExpandedState() {
    return this.expanded ? 'expanded' : 'collapsed';
  }
}
